// extracted by mini-css-extract-plugin
export default {"wrapper":"PhoneNumberValidationInput_wrapper__+NIpt"};